export { MyPlate } from './MyPlate';



// WEBPACK FOOTER //
// ./src/common/Components/MyPlate/index.js